import { format } from 'date-fns/format';
import { ru } from 'date-fns/locale/ru';
import { DateFormat } from '@common/const/date';

export const getCatalogItemDateFormat = (date: Date, showYear?: boolean): DateFormat => {
  if (date.getFullYear() === new Date().getFullYear() && !showYear) {
    return DateFormat.CatalogItemDateThisYear;
  }

  return DateFormat.CatalogItemDateAnotherYear;
};

export const formatCatalogItemDate = (date: Date, showYear?: boolean): string => {
  return format(date, getCatalogItemDateFormat(date, showYear), { locale: ru });
};
